module.exports = __webpack_public_path__ + "static/media/multiverse-mentoring.c2227dbc.md";